<template>
    <!--
          作者：kmdshop
          时间：2019-10-25
          描述：组件-选择全分类
      -->
    <el-dialog title="选择全分类" :visible.sync="dialogVisible" :append-to-body="true" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="900px">
      <div class="common-seach-wrap">
        <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
         
          <el-form-item label="全分类名称">
            <el-input placeholder="请输入全分类名称" v-model="formInline.search">
              <el-button slot="append" icon="el-icon-search" @click="getData">查询</el-button>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
  
      <!--内容-->
      <div class="product-content">
        <div class="table-wrap">
          <el-table size="small" :data="list" border style="width: 100%" highlight-current-row v-loading="loading" @selection-change="tableCurrentChange">
            <el-table-column width="70" label="全分类图片">
              <template slot-scope="scope">
                <img v-if="scope.row.images" :src="scope.row.images.file_path" width="30" height="30" />
              </template>
            </el-table-column>
            <el-table-column prop="name" label="全分类名称"></el-table-column>
           
            <el-table-column width="80" label="单选" >
              <template slot-scope="scope">
                <el-button size="mini" v-if="scope.row.noChoose" @click="SingleFunc(scope.row)">选择</el-button>
                <el-button size="mini" v-else disabled>已选</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
  
        <!--分页-->
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="curPage"
            :page-sizes="[2, 10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="totalDataNumber"
          ></el-pagination>
        </div>
      </div>
  
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible=false">取 消</el-button>
        <el-button size="small" type="primary" @click="addClerk" v-if="islist">确 定</el-button>
      </div>
    </el-dialog>
  </template>
  
  <script>
  import CategoryaApi from '@/api/categorya.js';
  export default {
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*当前是第几页*/
        curPage: 1,
        /*一页多少条*/
        pageSize: 10,
        /*一共多少条数据*/
        totalDataNumber: 0,
        formInline: {},
        //全分类列表
        list: [],
        multipleSelection: [],
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        /*结果类别*/
        type:'error',
        /*传出去的参数*/
        params:null
      };
    },
    props: ['isproduct', 'excludeIds','islist','index'],
    watch:{
      isproduct:function(n,o){
        if(n!=o){
          if(n){
            this.dialogVisible=n;
            this.type='error';
            this.params=null;
            this.getData();
          }
        }
      }
    },
    created() {
  
    },
    methods: {
  
      /*是否可以勾选*/
      selectableFunc(e){
        if(typeof e.noChoose !=='boolean'){
          return true;
        }
        return e.noChoose;
      },
  
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getData();
      },
  
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getData();
      },
  
      /*获取全分类列表*/
      getData() {
        console.log("走了吗")
        let self = this;
        let params = self.formInline;
        params.page = self.curPage;
        params.list_rows = self.pageSize;
        CategoryaApi.getList(params, true)
          .then(res => {
            if (res.code == 1) {
              self.loading = false;
              self.cateList = res.data.category;
              /*判断是否需要去重*/
              if(self.excludeIds&&typeof(self.excludeIds)!='undefined'&&self.excludeIds.length>0){
                res.data.list.data.forEach(item=>{
                  if(self.excludeIds.indexOf(item.categorya_id)>-1){
                    item.noChoose=false;
                  }else{
                    item.noChoose=true;
                  }
                });
              }else{
                if(!self.islist){
                   res.data.list.data.forEach(item=>{
                     item.noChoose=true;
                   });
                }
              }
              self.list = res.data.list.data;
              self.totalDataNumber = res.data.list.total;
            }
          })
          .catch(error => {});
      },
  
      /*单选*/
      SingleFunc(row){
        this.multipleSelection=[row];
        this.addClerk();
      },
  
      //点击确定
      addClerk() {
        let self = this;
        let params = null;
        let type = 'success';
        console.log("list",self.list)
        console.log("this.multipleSelection ",this.multipleSelection )
        if (self.multipleSelection.length < 1) {
          self.$message({
            message: '请至少选择一个产品全分类！',
            type: 'error'
          });
          return;
        }
        params = self.multipleSelection;

         self.params = params;
         self.type = 'success';
         self.dialogVisible = false;
      },
  
      /*关闭弹窗*/
      dialogFormVisible() {
        this.$emit('closeDialog', {
          type: this.type,
          openDialog: false,
          params: this.params,
          index:this.index
        });
      },
  
      /*监听复选按钮选中事件*/
      tableCurrentChange(val) {
        this.multipleSelection = val;
      }
    }
  };
  </script>
  
  <style>
   .no-list .el-checkbox{ display: none;}
  </style>
  


// WEBPACK FOOTER //
// src/components/categorya/index.vue